import { render, staticRenderFns } from "./AssessmentConsiderationsBlock.vue?vue&type=template&id=013cbd3c&scoped=true&"
import script from "./AssessmentConsiderationsBlock.vue?vue&type=script&lang=ts&"
export * from "./AssessmentConsiderationsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentConsiderationsBlock.vue?vue&type=style&index=0&id=013cbd3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013cbd3c",
  null
  
)

export default component.exports